import { max as mathMax, min as mathMin } from "./math.js";
export default function within(min, value, max) {
  return mathMax(min, mathMin(value, max));
}


//////////////////
// WEBPACK FOOTER
// ./~/.store/@popperjs+core@2.9.2/~/@popperjs/core/lib/utils/within.js
// module id = 326
// module chunks = 75